import { produce } from "immer";
class CanvasRenderingContext2DExtended {
  _ctx;
  constructor(ctx) {
    this._ctx = ctx;
  }
  fillTextWithEllipsis(text, maxTextWidth, x, y) {
    let result = text;
    let width = this._ctx.measureText(text).width;
    const ellipsis = "…";
    const ellipsisWidth = this._ctx.measureText(ellipsis).width;
    if (width > maxTextWidth && width > ellipsisWidth) {
      let len = text.length;
      result = produce(text, (draft) => {
        while (width >= maxTextWidth - ellipsisWidth && len-- > 0) {
          draft = draft.substring(0, len);
          width = this._ctx.measureText(draft).width;
        }
        return `${draft}${ellipsis}`;
      });
    }
    this._ctx.fillText(result, x, y);
  }
}
export {
  CanvasRenderingContext2DExtended
};
//# sourceMappingURL=CanvasRenderingContext2DExtended.js.map
